<template>
  <span
    class="icon"
    :style="maskStyle"
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import rssIcon from '@/assets/icons/rss.svg'

const maskStyle = computed(() => ({
  WebkitMask: `url(${rssIcon}) center / contain no-repeat`,
  mask: `url(${rssIcon}) center / contain no-repeat`
}))
</script>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background-color: currentColor;
}
</style>